import { Box, Button } from '@mui/material';
import { IconArrowUp } from '@tabler/icons-react';

type Props = { visible: boolean; loading: boolean; onClick: () => void };

export default function NewLeadsButton({ visible, loading, onClick }: Props) {
    return (
        <Box
            aria-live="polite"
            sx={{
                minHeight: 40,
                flexShrink: 0,
                display: 'flex',
                alignItems: 'center',
            }}
        >
            {visible && (
                <Button
                    variant="contained"
                    disabled={loading}
                    onClick={onClick}
                    startIcon={<IconArrowUp size={17} />}
                    sx={{
                        borderRadius: 8,
                        px: 2,
                        minHeight: 40,
                        bgcolor: 'var(--lm-accent)',
                        color: '#fff',
                        boxShadow: '0 3px 14px #0002',
                        '&:hover': { bgcolor: 'var(--lm-accent)' },
                    }}
                >
                    {loading ? 'Обновляем…' : 'Показать новые'}
                </Button>
            )}
        </Box>
    );
}
